'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NavItem = require('./NavItem');

Object.defineProperty(exports, 'NavItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_NavItem).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/navItem/index.js
// module id = 274
// module chunks = 0